import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import InputBoolean from '../internals/InputBoolean';

const SingleCheckbox = ({
  onChange,
  onBlur,
  variant,
  checked,
  ...otherProps
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const handleChange = callback => event => {
    const nextIsChecked = !isChecked;
    setIsChecked(nextIsChecked);

    if (callback) callback(nextIsChecked, event);
  };

  const handleBlur = event => {
    if (onBlur) onBlur(isChecked, event);
  };

  /* In case values has been updated outside this function,
    it'll refresh isChecked
  */
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <InputBoolean
      type='checkbox'
      onBlur={handleBlur}
      onChange={handleChange(onChange)}
      checked={isChecked}
      variant={variant}
      {...otherProps}
    />
  );
};

SingleCheckbox.defaultProps = {
  checked: false,
  variant: 'regular'
};

SingleCheckbox.propTypes = {
  checked: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  variant: InputBoolean.propTypes.variant,
  ...InputBoolean.propTypes
};

export default SingleCheckbox;
